export type SortableProcedure = {
  plannedStart?: string | null;
  createdAt?: string | null;
  id: string;
};

/**
 * Order procedures by planned start (default: latest first). Undated procedures
 * always trail dated ones, and ties break by createdAt (newest first, when
 * available) then id, so the order is stable. Compensates for PostGraphile
 * ordering NULLs first on DESC.
 */
export function sortProceduresByPlannedStart<T extends SortableProcedure>(procedures: T[], ascending: boolean): T[] {
  return [...procedures].sort((a, b) => {
    const aHas = !!a.plannedStart;
    const bHas = !!b.plannedStart;
    if (aHas !== bHas) return aHas ? -1 : 1;
    if (aHas && bHas && a.plannedStart !== b.plannedStart) {
      const cmp = (a.plannedStart as string) < (b.plannedStart as string) ? -1 : 1;
      return ascending ? cmp : -cmp;
    }
    const aCreated = a.createdAt ?? "";
    const bCreated = b.createdAt ?? "";
    if (aCreated !== bCreated) return aCreated < bCreated ? 1 : -1;
    return a.id < b.id ? -1 : 1;
  });
}
